import { actionTypes } from './action-types'
import type { FetchConfiguredUpliftPayload } from './types'

export type ConfiguredUpliftAction = ReturnType<typeof fetchConfiguredUplift>

export const fetchConfiguredUplift = ({ options }: { options: FetchConfiguredUpliftPayload }) => ({
  type: actionTypes.ENTITY_FETCH_BEGIN,
  payload: options,
  options,
})
